import { formatPhone } from './phoneHelper';

export const linkWhatsapp = (phone: string, country = 34, msg: string) => {
  return `https://wa.me/${formatPhone(phone, country.toString())}/?text=${msg}`;
};
